import React from 'react';
import { ChevronDownIcon, FilterIcon, FolderPlusIcon, PlusCircleIcon, SlidersIcon, SortAscIcon } from 'lucide-react';
export function SearchControls({
  selectedRowsCount = 0
}) {
  // Pagination component that can be reused
  const Pagination = () => <nav className="flex items-center" data-id="element-392">
      <button className="p-0.5 mr-0.5 text-gray-400" data-id="element-393">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-394">
          <path d="M15 18l-6-6 6-6" data-id="element-395" />
        </svg>
      </button>
      <button className="w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-sm" data-id="element-396">
        1
      </button>
      <button className="w-6 h-6 rounded-full text-gray-600 flex items-center justify-center text-sm mx-0.5" data-id="element-397">
        2
      </button>
      <button className="w-6 h-6 rounded-full text-gray-600 flex items-center justify-center text-sm mx-0.5" data-id="element-398">
        3
      </button>
      <button className="w-6 h-6 rounded-full text-gray-600 flex items-center justify-center text-sm mx-0.5" data-id="element-399">
        4
      </button>
      <button className="w-6 h-6 rounded-full text-gray-600 flex items-center justify-center text-sm mx-0.5" data-id="element-400">
        5
      </button>
      <button className="p-0.5 ml-0.5 text-gray-400" data-id="element-401">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-402">
          <path d="M9 18l6-6-6-6" data-id="element-403" />
        </svg>
      </button>
    </nav>;
  return <div className="bg-white border-b shadow-sm py-4 px-6" data-id="element-404">
      <div data-id="element-405">
        <h1 className="text-xl font-semibold text-gray-900" data-id="element-406">Search Results</h1>
        <p className="text-sm text-gray-500 mb-4" data-id="element-407">
          <span className="font-medium" data-id="element-408">3,670</span> result(s) found for{' '}
          <span className="text-indigo-600 font-medium" data-id="element-409">radiofrequency</span> +{' '}
          <span className="text-indigo-600 font-medium" data-id="element-410">false</span>
        </p>
      </div>
      <div className="flex items-center justify-between pr-[345px]" data-id="element-411">
        <div className="flex items-center space-x-3" data-id="element-412">
          <div className="relative mr-3" data-id="element-413">
            <div className="flex items-center" data-id="element-414">
              <SortAscIcon size={16} className="text-gray-500 mr-1.5" data-id="element-415" />
              <select className="pl-1 pr-8 py-1.5 text-sm bg-white border rounded appearance-none" data-id="element-416">
                <option data-id="element-417">Sort by: New to Old</option>
                <option data-id="element-418">Sort by: Old to New</option>
                <option data-id="element-419">Sort by: Relevance</option>
                <option data-id="element-420">Sort by: A-Z</option>
              </select>
              <ChevronDownIcon size={14} className="text-gray-500 absolute right-2" data-id="element-421" />
            </div>
          </div>
          <button className="px-3 py-1.5 text-sm bg-white border rounded flex items-center" data-id="element-422">
            <FilterIcon size={14} className="mr-1.5 text-gray-500" data-id="element-423" />
            Filters
          </button>
          <button className={`px-3 py-1.5 text-sm border rounded flex items-center ${selectedRowsCount > 0 ? 'bg-indigo-50 text-indigo-700 border-indigo-300' : 'bg-white'}`} data-id="element-424">
            <FolderPlusIcon size={14} className={`mr-1.5 ${selectedRowsCount > 0 ? 'text-indigo-600' : 'text-gray-500'}`} data-id="element-425" />
            Create Report
          </button>
          {selectedRowsCount > 0 && <button className="px-3 py-1.5 text-sm bg-indigo-50 text-indigo-700 border border-indigo-300 rounded flex items-center" data-id="element-426">
              <PlusCircleIcon size={14} className="mr-1.5 text-indigo-600" data-id="element-427" />
              Add to Report ({selectedRowsCount})
            </button>}
        </div>
        <div className="flex items-center" data-id="element-428">
          <Pagination data-id="element-429" />
        </div>
      </div>
    </div>;
}